import { Component, inject } from "@angular/core";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatButtonModule } from "@angular/material/button";
import {
  MatBottomSheet,
  MatBottomSheetModule,
} from "@angular/material/bottom-sheet";
import { MatBadgeModule } from "@angular/material/badge";
import { ProfileComponent } from "../profile/profile.component";
import { AgendaService } from "../agenda/agenda.service";
import { Router, RouterLink } from "@angular/router";
import { Store, select } from "@ngrx/store";
import { AppState } from "../app.state";
import { selectUsuario } from "../states/usuario/selector";
import { iUsuario } from "../usuario/usuario.interface";
import { UsuarioService } from "../usuario/usuario.service";
import { Observable, Subject, Subscription, firstValueFrom } from "rxjs";
import { MenuService } from "./menu.service";
import { selectFormasEnvioContador } from "../states/despacho/selector";
import { IContador } from "../interfaces/despacho";
import { CommonModule } from "@angular/common";
import { LoadingService } from "../loading/loading.service";
import { onChildChanged } from "firebase/database";
import { LoginService } from "../login/login.service";

@Component({
  selector: "app-menu",
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatBadgeModule,
    RouterLink,
    CommonModule,
  ],
  templateUrl: "./menu.component.html",
  styleUrl: "./menu.component.css",
})
export class MenuComponent {
  private agendaService = inject(AgendaService);
  private usuarioService = inject(UsuarioService);
  private loadingService = inject(LoadingService);
  private menuService = inject(MenuService);
  private loginService = inject(LoginService);
  private router = inject(Router);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  private subscriptions = new Subscription();
  public _bottomSheet = inject(MatBottomSheet);

  public oUsuario: any;
  public showCatalogos: boolean = false;
  public showFE: boolean = false;
  public isAdministrador: boolean = false;
  public isCoordnador: boolean = false;
  public catTemasLectura: string[] = [];
  public usuario: any = false;
  public statusMenu: boolean = true;
  public contador$!: Observable<IContador>;

  constructor() {
    this.oUsuario = this.usuarioService.getUsuario();
    this.contador$ = this.store.select(selectFormasEnvioContador);
  }

  ngOnInit() {
    this.subscriptions.add(
      this.oUsuario.subscribe((user: any) => {
        this.catTemasLectura = [];
        for (const key in user.temas) {
          const item = user.temas[key];
          if (item.permiso == 1 || item.permiso >= 3) {
            this.catTemasLectura.push(key);
          }
        }

        this.isAdministrador = user.rol == 4;
        this.isCoordnador = user.rol == 3;
        this.usuario = user;

        this.listenerUsuario();
      })
    );

    this.subscriptions.add(
      this.menuService.listenerMenu$.subscribe((status: any) => {
        this.statusMenu = status;
      })
    );
  }

  listenerUsuario() {
    const usuarioRef = this.menuService.getReferenciaUsuario(this.usuario.uid);
    onChildChanged(usuarioRef, (data: any) => {
      console.log("CAMBIOS EN LOS DATOS DEL USUARIO");
      console.log(data.key, data.val());
      this.loginService.logout();
    });
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  openBottomPerfil(): void {
    this._bottomSheet.open(ProfileComponent);
  }

  openTutorial(): void {
    window.open('https://youtu.be/R_neDooGgik', '_blank');
  }

  openManual(): void {
    window.open('https://docs.google.com/document/d/1P2uR5Z0eDXLl0AbzlmcVlZhJyoaBUcLWl8XzwhzkjHg/edit', '_blank');
  }

  changeTema(tema: string) {
    this.agendaService.changeTemaAgenda(tema);
  }

  goHome() {
    this.router.navigate([`/agenda`]);
    this.changeTema('ALL');
  }

  regresarSO() {
    this.loadingService.show();
    if(this.usuario && this.usuario.uid)
      this.menuService.setUsuarioMigrado(this.usuario.uid);
    else
      this.loadingService.hide();
  }
}
